import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2fa33a30"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa33a30')) {
      api.createRecord('2fa33a30', component.options)
    } else {
      api.reload('2fa33a30', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=2fa33a30", function () {
      api.rerender('2fa33a30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/blog/edit.vue"
export default component.exports